"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13, _context14, _context15, _context16, _context17, _context18, _context19, _context20, _context21;

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

var _exportNames = {
  register: true
};
exports.register = void 0;

var _appInfo = require("@onviobr/app-info");

var _bmAlert = require("./bm-alert");

_forEachInstanceProperty(_context = _Object$keys(_bmAlert)).call(_context, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmAlert[key];
    }
  });
});

var _bmAlerts = require("./bm-alerts");

_forEachInstanceProperty(_context2 = _Object$keys(_bmAlerts)).call(_context2, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmAlerts[key];
    }
  });
});

var _bmBadge = require("./bm-badge");

_forEachInstanceProperty(_context3 = _Object$keys(_bmBadge)).call(_context3, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmBadge[key];
    }
  });
});

var _bmButton = require("./bm-button");

_forEachInstanceProperty(_context4 = _Object$keys(_bmButton)).call(_context4, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmButton[key];
    }
  });
});

var _bmIcon = require("./bm-icon");

_forEachInstanceProperty(_context5 = _Object$keys(_bmIcon)).call(_context5, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmIcon[key];
    }
  });
});

var _bmIcons = require("./bm-icons");

_forEachInstanceProperty(_context6 = _Object$keys(_bmIcons)).call(_context6, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmIcons[key];
    }
  });
});

var _bmInput = require("./bm-input");

_forEachInstanceProperty(_context7 = _Object$keys(_bmInput)).call(_context7, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmInput[key];
    }
  });
});

var _bmLoading = require("./bm-loading");

_forEachInstanceProperty(_context8 = _Object$keys(_bmLoading)).call(_context8, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmLoading[key];
    }
  });
});

var _bmModal = require("./bm-modal");

_forEachInstanceProperty(_context9 = _Object$keys(_bmModal)).call(_context9, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmModal[key];
    }
  });
});

var _bmPopover = require("./bm-popover");

_forEachInstanceProperty(_context10 = _Object$keys(_bmPopover)).call(_context10, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmPopover[key];
    }
  });
});

var _bmSelect = require("./bm-select");

_forEachInstanceProperty(_context11 = _Object$keys(_bmSelect)).call(_context11, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmSelect[key];
    }
  });
});

var _bmTabItem = require("./bm-tab-item");

_forEachInstanceProperty(_context12 = _Object$keys(_bmTabItem)).call(_context12, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmTabItem[key];
    }
  });
});

var _bmTabSet = require("./bm-tab-set");

_forEachInstanceProperty(_context13 = _Object$keys(_bmTabSet)).call(_context13, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmTabSet[key];
    }
  });
});

var _bmToggle = require("./bm-toggle");

_forEachInstanceProperty(_context14 = _Object$keys(_bmToggle)).call(_context14, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmToggle[key];
    }
  });
});

var _bmDropdown = require("./bm-dropdown");

_forEachInstanceProperty(_context15 = _Object$keys(_bmDropdown)).call(_context15, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmDropdown[key];
    }
  });
});

var _bmTree = require("./bm-tree");

_forEachInstanceProperty(_context16 = _Object$keys(_bmTree)).call(_context16, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmTree[key];
    }
  });
});

var _bmDate = require("./bm-date");

_forEachInstanceProperty(_context17 = _Object$keys(_bmDate)).call(_context17, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmDate[key];
    }
  });
});

var _bmExpansionPanel = require("./bm-expansion-panel");

_forEachInstanceProperty(_context18 = _Object$keys(_bmExpansionPanel)).call(_context18, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmExpansionPanel[key];
    }
  });
});

var _utils = require("./utils");

_forEachInstanceProperty(_context19 = _Object$keys(_utils)).call(_context19, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});

var _bmBreadcrumb = require("./bm-breadcrumb");

_forEachInstanceProperty(_context20 = _Object$keys(_bmBreadcrumb)).call(_context20, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmBreadcrumb[key];
    }
  });
});

var _bmBreadcrumbItem = require("./bm-breadcrumb-item");

_forEachInstanceProperty(_context21 = _Object$keys(_bmBreadcrumbItem)).call(_context21, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bmBreadcrumbItem[key];
    }
  });
});

var version = "8.15.0";
var name = "@onviobr/ui-elements";

var register = function register() {
  (0, _bmAlert.registerAlert)();
  (0, _bmAlerts.registerAlerts)();
  (0, _bmIcon.registerIcon)();
  (0, _bmLoading.registerLoading)();
  (0, _bmModal.registerModal)();
  (0, _bmPopover.registerPopover)();
  (0, _bmSelect.registerSelect)();
  (0, _bmTabItem.registerTabItem)();
  (0, _bmTabSet.registerTabSet)();
  (0, _bmToggle.registerToggle)();
  (0, _bmDropdown.registerDropdown)();
  (0, _bmTree.registerTree)();
  (0, _bmTree.registerVirtualizedTree)();
  (0, _bmDate.registerDate)();
  (0, _bmExpansionPanel.registerBmExpansionPanel)();
  (0, _bmExpansionPanel.registerBmExpansionPanelAddButton)();
  (0, _bmExpansionPanel.registerBmExpansionPanelRemoveButton)();
  (0, _bmBreadcrumb.registerBreadcrumb)();
  (0, _bmBreadcrumbItem.registerBreadcrumbItem)();
};

exports.register = register;
(0, _appInfo.registerLibrary)({
  version: version,
  name: name
});
